<template>
  <div>
    <div class="box">
      <!-- <video 
        id="video"
        ref="videoDivA" class="video-js vjs-default-skin"
        :src="src"
        controls
      ></video> -->
      <div id="container"></div>
      <div class="mt-10">
        <div class="title">{{ title }}</div>
        <div class="tips">
          <div class="tip">主讲人：{{ teacherName }}</div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { getCourseDetail, saveCourse } from "@/api/index";
import { getLiveDetail } from '@/api/index';
// import videojs from 'video.js';
// import 'video.js/dist/video-js.css';
import { QNRTPlayer } from "qn-rtplayer-web";

export default {
  data() {
    return {
      info: {},
      timer: null,                // 定时器
      elapsedTime: 0,             // 已经过的时间
      lastSavedTime: 0,           // 上次保存的时间
      isPaused: false,            // 视频是否暂停
      isContinue: false,

      title: '',
      teacherName: '',
      src: '',
      videoInstanceA: null, //主流
    }
  },
  mounted() {
    getLiveDetail(this.$route.query).then(res => {
      this.title = res.title
      this.teacherName = res.teacherName
      this.src = res.hlsdza.replace('http://pili-live-hls.zb.whxunw.com', 'https://pili-live-hls-zb.whxunw.com');
      
      const player = new QNRTPlayer();
      player.init({
        controls: true,
        height: '648px'
      });
      // 3. 传入播放地址及容器，开始播放
      player.play(
        this.src ,
        document.getElementById("container")
      )
      // let options = {
      //   autoplay: true,
      //   controls: true,
      //   sources: [{
      //     type: 'application/x-mpegURL',
      //     src: this.src
      //   }]
      // };
      // this.$nextTick(() => {
      //   this.videoInstanceA = videojs(this.$refs.videoDivA, options, function onPlayerReady() {});
      // })
    })
  },
  methods: {

  },
  beforeDestroy() {
    
  },
}
</script>

<style lang="scss" scoped>
.box {
  padding: 30px 24px 32px 24px;
  background-color: #fff;
}

#container {
  background-color: #000;
  width: 100%;
  height: 648px;
}

.title {
  font-weight: 500;
  font-size: 18px;
  color: #1A1A1A;
  line-height: 24px;
  margin-bottom: 12px;
}

.tips {
  display: flex;
  gap: 20px;

  .tip {
    padding: 0 6px;
    line-height: 24px;
    background: #EEEEEE;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    color: #767676;
  }
}
</style>
